import Certification from '@components/LocalMerchant/Certification'

export default {
  path: 'certification',
  component: Certification,
  stat: '品牌代理认证'
}
